import React, { useState } from "react"
import './MaterialsBlock.scss'
import { Container, Nav, Tab } from "react-bootstrap";
import LinkDropdown from "../LinkDropdown";

function MaterialsBlock() {

    const [activeTab, setActiveTab] = useState('tab1');

    return (
        <div className={`materials-block`} id="materials">
            <Container>
                <h3>Материалы для подготовки</h3>
            </Container>
            <Tab.Container
                activeKey={activeTab}
                onSelect={(key) => setActiveTab(key)}
            >

                <div className="tab-pills-container">
                    <Nav variant="pills" className="">
                        <Nav.Item>
                            <Nav.Link eventKey="tab1">
                                <div className={`nav-tab ${activeTab === 'tab1' ? "nav-tab-active" : "nav-tab-unactive"}`}>
                                    <div className={`title ${activeTab === 'tab1' && "title-active"}`}>
                                        Русский как иностранный (РКИ)
                                    </div>
                                    <div className={`vertical-line ${activeTab === 'tab1' && "vertical-line-active"}`}></div>
                                    <div className={`array-button ${activeTab === 'tab1' && "array-button-active"}`}>
                                        <div className={`array ${activeTab === 'tab1' && "array-active"}`}></div>
                                    </div>
                                </div>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="">
                            <Nav.Link eventKey="tab2">
                                <div className={`nav-tab ${activeTab === 'tab2' ? "nav-tab-active" : "nav-tab-unactive"}`}>
                                    <div className={`title ${activeTab === 'tab2' && "title-active"}`}>
                                        Русский — язык обучения
                                    </div>
                                    <div className={`vertical-line ${activeTab === 'tab2' && "vertical-line-active"}`}></div>
                                    <div className={`array-button ${activeTab === 'tab2' && "array-button-active"}`}>
                                        <div className={`array ${activeTab === 'tab2' && "array-active"}`}></div>
                                    </div>
                                </div>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>

                <Tab.Content className="tab-content">
                    <Tab.Pane eventKey="tab1">
                        <div className="tab-pane">
                            <Container className="tab-container">
                                <div className="col1">
                                    <h4>Отборочный этап</h4>
                                    <div className="downloads-block">
                                        <a className="downloads-item" href={`${window.location.origin}/docs/Задания_РКИ_ДЕМО.pdf`} target="_blank" rel="noreferrer">
                                            <div className="up-text">
                                                cкачать материал
                                            </div>
                                            <div className="down-part">
                                                <div className="title">
                                                    {"Демоверсии \nзаданий"}
                                                </div>
                                                <div className="download-icon"></div>
                                            </div>
                                        </a>
                                        <div className="downloads-item">
                                            <div className="up-text">
                                                cкачать материал
                                            </div>
                                            <div className="down-part">
                                                <div className="title">
                                                    {"Как подготовиться \nк тесту"}
                                                </div>
                                                <LinkDropdown
                                                    variant="light"
                                                    className='download-icon'
                                                    buttonClassName='download-icon no-caret'
                                                    menuClassName='invite-dropdown'
                                                    items={[
                                                        { label: 'Как подготовиться к тесту', href: `${window.location.origin}/docs/Как_подготовиться_к_тесту_РКИ.pdf`, props: { target: "_blank", rel: "noreferrer" } },
                                                        { label: 'Методические разработки к урокам для подготовки', href: `${window.location.origin}/docs/Методические_разработки_к_урокам_для_подготовки_к_Олимпиаде_Даля.zip`, props: { target: "_blank", rel: "noreferrer" } },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col1">
                                    <h4>Заключительный этап</h4>
                                    <div className="downloads-block">
                                        <a className="downloads-item" href={`${window.location.origin}/docs/Как_подготовиться_к_эссе_РКИ.pdf`} target="_blank" rel="noreferrer">
                                            <div className="up-text">
                                                cкачать материал
                                            </div>
                                            <div className="down-part">
                                                <div className="title">
                                                    {"Как подготовиться \nк эссе"}
                                                </div>
                                                <div className="download-icon"></div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="tab2">
                        <div className="tab-pane">
                            <Container className="tab-container">
                                <div className="col1">
                                    <h4>Отборочный этап</h4>
                                    <div className="downloads-block">
                                        <a className="downloads-item" href={`${window.location.origin}/docs/Задания_РЯ_ДЕМО.pdf`} target="_blank" rel="noreferrer">
                                            <div className="up-text">
                                                cкачать материал
                                            </div>
                                            <div className="down-part">
                                                <div className="title">
                                                    {"Демоверсии \nзаданий"}
                                                </div>
                                                <div className="download-icon"></div>
                                            </div>
                                        </a>
                                        <div className="downloads-item">
                                            <div className="up-text">
                                                cкачать материал
                                            </div>
                                            <div className="down-part">
                                                <div className="title">
                                                    {"Как подготовиться \nк тесту"}
                                                </div>
                                                <LinkDropdown
                                                    variant="light"
                                                    className='download-icon'
                                                    buttonClassName='download-icon no-caret'
                                                    menuClassName='invite-dropdown'
                                                    items={[
                                                        { label: 'Как подготовиться к тесту', href: `${window.location.origin}/docs/Как_подготовиться_к_тесту_Русский_язык_обучения.pdf`, props: { target: "_blank", rel: "noreferrer" } },
                                                        { label: 'Методические разработки к урокам для подготовки', href: `${window.location.origin}/docs/Методические_разработки_к_урокам_для_подготовки_к_Олимпиаде_Даля.zip`, props: { target: "_blank", rel: "noreferrer" } },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col1">
                                    <h4>Заключительный этап</h4>
                                    <div className="downloads-block">
                                        <a className="downloads-item" href={`${window.location.origin}/docs/Как_подготовиться_к_эссе_РЯ.pdf`} target="_blank" rel="noreferrer">
                                            <div className="up-text">
                                                cкачать материал
                                            </div>
                                            <div className="down-part">
                                                <div className="title">
                                                    {"Как подготовиться \nк эссе"}
                                                </div>
                                                <div className="download-icon"></div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
}

export default MaterialsBlock;